<template>
  <div>
    <transition name="fade">
      <div class="loader" v-if="loading">
        <v-progress-circular
          v-if="spinner"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
      required: true
    },
    spinner: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.loader {
  position: absolute !important;
  z-index: 10 !important;
  width: 100% !important;
  height: 100% !important;
  background: rgba(255, 255, 255, 0.6) !important;
  display: flex !important;
  justify-content: space-around !important; 
  align-items: center !important;
}
.fade-enter-active, .fade-leave-active {
  transition: all 1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>